export const setRequestCompany = (state, payload) => state.request_company = payload;
